import { KEYBOARDING_STUDENT_EXPORT_FRAGMENT_LEGACY } from 'graph/fragments/keyboarding-student-export';
import gql from 'graphql-tag';

const KEY_EXPORT_STUDENT_REPORT_QUERY = gql`
  query getStudentReportExporting($id: Int!, $dateRange: DateRangeInput!) {
    students: keyClassroomEngagementReport(where: { studentId: $id }, dateRange: $dateRange) {
      ...BaseKeyboardingStudentExportLegacy
    }
  }
  ${KEYBOARDING_STUDENT_EXPORT_FRAGMENT_LEGACY}
`;

export default KEY_EXPORT_STUDENT_REPORT_QUERY;
